// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3RznM","productName":"Table_productName__Niu-i"};